import { render, staticRenderFns } from "./DataTableSortingPagination.vue?vue&type=template&id=f629c222"
import script from "./DataTableSortingPagination.vue?vue&type=script&lang=js"
export * from "./DataTableSortingPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports